<template>
  <div class="video-player-container">
    <video
      ref="videoPlayer"
      class="video-js vjs-big-play-centered"
    ></video>
  </div>
</template>

<script>
import videojs from "video.js";
//样式文件注意要加上
import "video.js/dist/video-js.css"; 
export default {
  name: "VideoPlayer",
  props: ['videoUrl'],
  data () {
    return {
      player: null,
      isVisible: false,
      observer: null
    }
  },
  watch: {
    videoUrl: {
      handler(newUrl, oldVal) {
        this.handleUrlChange(newUrl)
        // 计算动态高度或更新 RecycleScroller
      },
      deep: true, // 深度监听
      immediate: true, // 立即执行一次
    }
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.disposePlayer();
  },
  mounted() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.isVisible = true;
          this.$nextTick(() => {
            if (this.videoUrl) {
              this.initPlayer(this.videoUrl);
            }
          });
          this.observer.unobserve(this.$refs.videoPlayer);
        }
      });
    });
    this.observer.observe(this.$refs.videoPlayer);
  },
  methods: {
    initPlayer (newUrl) {
      console.log(this.$refs.videoPlayer, 'this.$refs.videoPlayer')
      if (!this.$refs.videoPlayer) {
        console.error('Video element not found')
        return
      }
      // 合并默认配置和传入的配置
      const videoOptions = {
        autoplay: false,
        controls: true,
        interactive: true,
        playbackRates: [1, 1.25, 1.5, 2],
        sources: [
          // {src: 'http://120.27.251.79:18888//fileview/spark/10002158/singlefile/81b7a70e-a8c8-4b03-a831-6718e66e63e9.mp4?SkSign=d36c98888447db19f621631b864d448c&SkExpire=1754313598494', type: 'video/mp4;video/mov'}
          // {src: 'https://www.w3schools.com/html/mov_bbb.mp4', type: 'video/mp4;video/mov'}
          {src: newUrl, type: 'video/mp4;video/mov'}
        ]
      }
      const playerOptions = {
        preload: 'auto',
        fluid: true,
        controlBar: {
          volumePanel: {
            inline: false,
            volumeControl: {
              vertical: true
            }
          }
        },
        ...videoOptions
      }
      // 初始化播放器
      this.player = videojs(
        this.$refs.videoPlayer,
        playerOptions,
        function onPlayerReady() {
          const onMetadataLoaded = () => {
            console.log('视频元数据已加载，视频时长:', this.duration()); // 添加时长信息
            console.log('视频元数据已加载，进度条应可操作');
            // 执行 load 方法
            this.load(); 
            // 移除事件监听
            this.off('loadedmetadata', onMetadataLoaded); 
          };
          this.on('loadedmetadata', onMetadataLoaded);
          this.on('play', () => {
            console.log('视频开始播放')
          })
          this.on('pause', () => {
            console.log('视频已暂停')
          })
          this.on('ended', () => {
            console.log('视频播放结束')
          })
          // 添加错误监听
          this.on('error', () => {
            console.error('视频播放器出错:', this.error());
          });
          // 可以在这里添加播放器准备就绪后的逻辑
        }
      )
      // 将播放器实例暴露给父组件
      // this.$emit('player-init', this.player)
    },
    handleUrlChange(newUrl) {
      if (!this.player) {
        this.initPlayer(newUrl)
        return
      }
      // 小技巧：先暂停再切换源
      this.player.pause()
      this.player.src({
        src: newUrl,
        type: 'video/mp4;video/mov'
      })
      // 强制重新加载（解决某些浏览器缓存问题）
      this.$nextTick(() => {
        this.player.load()
      })
    },



    // handlePlayerInit(player) {
    //   this.player = player
    //   console.log('播放器实例已获取', player)
      
    //   // 可以在这里添加事件监听
    //   player.on('play', () => {
    //     console.log('视频开始播放')
    //   })
      
    //   player.on('pause', () => {
    //     console.log('视频已暂停')
    //   })
      
    //   player.on('ended', () => {
    //     console.log('视频播放结束')
    //   })
    // },
    disposePlayer () {
      if (this.player) {
        this.player.dispose();
        this.player = null;
      }
    }
  },
  beforeDestroy () {
    this.disposePlayer()
  },
}
</script>

<style lang='scss'>
.video-player-container {
  // width: 70%;
  // height: 300px;
  // margin: 0 auto;
  .video-js {
    width: 100%;
    // height: 100%;
    background: none;
    text-align: center;
  }
  // .vjs-has-started .vjs-control-bar {
  //   // height: 0.6rem !important;
  // }
  // .vjs-button > .vjs-icon-placeholder:before {
  //   // font-size: 3rem!important;
  // }
  // .video-js.vjs-fluid:not(.vjs-audio-only-mode){
  //   height: 300px; 
  // }
  // .video-js .vjs-tech {
  //   height: 300px;
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/VideoPlayer/index.vue